import FixaTable, {
  FixaTableBody,
  FixaTableHeader,
} from "../../../shared/wrappers/FixaTable/FixaTable";
import { formatIsoDate } from "@coworker/app/src/components/Insights/helpers";
import Trans from "../../../../../packages/locales/translations/util/Trans";
import rolesTranslations from "../../constants/roleTranslations";
import { UserWithTeamName } from "../../types/UserWithTeamName";
import NoTableData from "./NoTableData";
import SkeletonTableRows from "./TableSkeleton";

interface TeamUsersTableProps {
  users: UserWithTeamName[];
  storeName?: string;
  selectedTeam?: { id: string; name: string };
  isLoading: boolean;
  resetFilters: () => void;
}

const TeamUsersTable = ({
  users,
  storeName = "",
  selectedTeam,
  isLoading,
  resetFilters,
}: TeamUsersTableProps) =>
  users?.length === 0 && !isLoading ? (
    <NoTableData
      title={selectedTeam ? "noUsersInStoreString" : "noUsersInTeamString"}
      titleTranslationValues={
        selectedTeam ? { teamName: selectedTeam.name } : { storeName }
      }
      description={
        selectedTeam
          ? "noUsersInStoreDescriptionString"
          : "noUsersInTeamDescriptionString"
      }
      resetFilters={resetFilters}
    />
  ) : (
    <FixaTable fullWidth>
      <FixaTableHeader>
        <tr>
          <th>
            <Trans>nameString</Trans>
          </th>
          <th>
            <Trans>emailString</Trans>
          </th>
          {!selectedTeam && (
            <th>
              <Trans>teamString</Trans>
            </th>
          )}
          <th>
            <Trans>roleString</Trans>
          </th>
          <th>
            <Trans>lastActiveAtString</Trans>
          </th>
        </tr>
      </FixaTableHeader>
      <FixaTableBody>
        {isLoading ? (
          <SkeletonTableRows />
        ) : (
          users?.map((user) => (
            <tr key={user.uid}>
              <td>{user.fullName}</td>
              <td>{user.email}</td>
              {!selectedTeam && <td>{user.teamName}</td>}
              <td>
                <Trans>{rolesTranslations[user.roleId]}</Trans>
              </td>
              <td>
                {user["lastActiveAt"]
                  ? formatIsoDate(user["lastActiveAt"])
                  : "Never"}
              </td>
            </tr>
          ))
        )}
      </FixaTableBody>
    </FixaTable>
  );

export default TeamUsersTable;
